import InputFilterBox from '../InputFilterBox/web';
import { labelForBedroomsAndBathrooms } from 'src/utils/Functions';
import { useFilters } from 'shared-components/Components/Filters/Filters.hook';
import { useContext, useRef } from 'react';
import { useSearchResultsFilters } from '../../Filters/SearchResultsFilters.hook';
import { Bedrooms } from 'shared-components/Components/Filters/Bedrooms/web';
import { Rooms } from 'shared-components/Components/Filters/Rooms/web';
import { Bathrooms } from 'shared-components/Components/Filters/Bathrooms/web';
import { showBedrooms, showRooms } from '@Utils/Functions';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';

type BedroomsAndBathroomsProps = {
	alwaysOpen?: boolean,
	show?: boolean
}

export const BedroomsAndBathrooms = ({alwaysOpen = false, show = false} : BedroomsAndBathroomsProps) => {
    if (!show) return null;
     
	const { country_code } = useContext(ConfigStateContext);
    const { filters, filtersTags, showFilter } = useFilters();
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const submitBedrooms = useRef(null)
	const showRoomsText = showRooms(filters?.property_type_id, country_code) && !showBedrooms(filters?.property_type_id, filters?.operation_type_id, country_code);
    const bedroomsDescription: string = labelForBedroomsAndBathrooms(filtersTags, showRoomsText, country_code !== 'CO');

    const body = (
        <div className="optionList add-padding filter-options--shrink">
            <Bedrooms
                collapsable={false}
                filterChanged={changeFilters}
                inputType="buttonGroup"
                show={showFilter.bedroom}
            />

            <Rooms
                collapsable={false}
                filterChanged={changeFilters}
                inputType="buttonGroup"
                show={showFilter.rooms}
            />

            <Bathrooms
                collapsable={false}
                filterChanged={changeFilters}
                inputType="buttonGroup"
                show={showFilter.bathrooms}
            />
        </div>
    )

    if(alwaysOpen) return body

    const handleCleanFilter = () => {
        const valuesToReset = {
            bedrooms: [],
            bedroomsExactMode: false,
            bathrooms: [],
            bathroomsExactMode: false,
            rooms: [],
            roomsExactMode: false
        }

        changeFilters(valuesToReset)
    }

    return (
        <InputFilterBox
            active={filters?.bedrooms?.length>0 || filters?.rooms?.length>0 || filters?.bathrooms?.length>0}
            label={bedroomsDescription} customWidth={430}
            customHeight={200}
            clossers={[submitBedrooms]}
            onCancelFilter={handleCleanFilter}
            scrollable
        >
            {body}
        </InputFilterBox>
    )
}
